import * as angular from 'angular';
import { DirectiveDefinition } from '../directiveDefinition';
import { guidEmpty } from '../../common';

interface DefaultVMScope extends angular.IScope {
    vm: any;
}

class WtQualifierValidatorController implements angular.IController {
    static $inject = ['$scope', '$element'];

    constructor(
        private _$scope: DefaultVMScope,
        private _$element: angular.IAugmentedJQuery
    ) {
    }

    $onInit() {
        const scope = this._$scope;
        const controller = this._$element.controller('ngModel');
        controller.$validators.required = (modelValue, viewValue) => {
            let isValid = true;
            if (scope.vm.properties && scope.vm.properties.length > 0
                && (controller.$isEmpty(modelValue) || controller.$isEmpty(viewValue) || viewValue === guidEmpty)
                && !scope.vm.disabled) {
                isValid = false;
            }
            return isValid;
        };
    }
}

export const wtQualifierValidator: DirectiveDefinition = {
    directiveId: 'wtQualifierValidator',
    restrict: 'A',
    controller: WtQualifierValidatorController,
    require: ['ngModel']
};